var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.70729 37.7071C1.31676 37.3166 1.31676 36.6834 1.70729 36.2929L36.2931 1.70711C36.6836 1.31658 37.3168 1.31658 37.7073 1.70711L39.1215 3.12132C39.512 3.51184 39.512 4.14501 39.1215 4.53553L4.53571 39.1213C4.14519 39.5118 3.51203 39.5118 3.1215 39.1213L1.70729 37.7071Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7071 39.1213C37.3166 39.5118 36.6834 39.5118 36.2929 39.1213L1.70711 4.53553C1.31658 4.14501 1.31658 3.51184 1.70711 3.12132L3.12132 1.70711C3.51184 1.31658 4.14501 1.31658 4.53553 1.70711L39.1213 36.2929C39.5118 36.6834 39.5118 37.3166 39.1213 37.7071L37.7071 39.1213Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_Close.e681806f10aece18b670a5de47d27e00.svg";
export { ForwardRef as ReactComponent };